import React, { useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import CustomButton from "../../../../components/common/button/CustomButton";
import closeIcon from "../../../../assets/closeModel.png";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import { useSelector } from "react-redux";

interface AlertCompleteSurveyPopupProps {
  title?: string;
  open: boolean;
  onHide?: () => void;
  clientDetails?: any;
  setFormData?: any;
  formData?: any;
  setIsCompletedRole?: any;
  alertModalShow: boolean;
  setAlertModelShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
  resetAllValidator?: any;
  setIsClickReset?: any;
}
const AlertCompleteSurvey: React.FC<AlertCompleteSurveyPopupProps> = ({
  onHide,
  title,
  alertModalShow,
  setAlertModelShow,
  setIsClickReset,
  setIsCompletedRole,
}) => {
  const { user } = useSelector((state: any) => state?.user);
  const classes = useStyles();
  const closeModel = () => {
    setAlertModelShow(false);
    setIsCompletedRole(false);
  };

  const submitHandler = () => {
    setIsClickReset(true);
  };

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition

  return (
    <>
      <Popup
        open={alertModalShow}
        title={"Complete Survey?"}
        onHide={closeModel}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={closeModel}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            <CustomButton variant="outlined" title="No" onClick={closeModel} />
            <CustomButton title="Yes" onClick={submitHandler} />
          </>
        }
      >
        <DialogContent sx={{ padding: "0px" }}>
          <DialogContentText>
            <Alert
              sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
              severity="warning"
            >
              Are you sure you want to complete the survey?{" "}
              {/* {user?.user?.roles.includes("TENANT") ||
              user?.user?.roles.includes("Admin") ||
              user?.user?.roles.includes("Owner")
                ? ""
                : `The survey details won't be editable once marked completed.`} */}
            </Alert>
          </DialogContentText>
        </DialogContent>
      </Popup>
    </>
  );
};
export default AlertCompleteSurvey;
